export default "__VITE_ASSET__CdlW_0N7__"